import { lazy } from 'react';

import ProfileSideBarMenu from './components/Profiles/ProfileSideBarMenu';
import UserReportsSideBarMenu from './components/Profiles/UserProfileSidebarMenu';

import Authorization from './Helpers/Authorization';

// site title
export const siteTitle = 'Daimler Trucks';
export const siteMetaDescription = 'Daimler Trucks';

export const setTitle = title => {
  document.title = title || siteTitle;
};

export const setMetaDescription = description => {
  document
    .querySelector('meta[name="description"]')
    .setAttribute('content', description || siteMetaDescription);
};
const userRole = Authorization.getAuthUserRole();

export const ROUTE = [
  // Login
  {
    private: false,
    exact: true,
    id: 1,
    path: '/',
    meta: {
      title: siteTitle,
      description: siteMetaDescription,
    },
    sideBar: false,
    component: lazy(() => import('./components/Login')),
    beta: false,
  },
  // Login
  {
    private: false,
    exact: true,
    id: 2,
    path: '/login',
    sideBar: false,
    meta: {
      title: siteTitle,
      description: siteMetaDescription,
    },
    component: lazy(() => import('./components/Login')),
    beta: false,
  },
  // Forgot-Password
  {
    private: false,
    path: '/forgot-password',
    id: 3,
    sideBar: false,
    exact: true,
    meta: {
      title: siteTitle,
      description: siteMetaDescription,
    },
    component: lazy(() => import('./components/Forgetpassword')),
    beta: false,
  },
  // Driver-Profile
  {
    private: true,
    path: '/profiles/driver',
    id: 4,
    sideBar: true,
    exact: true,
    sideBarMenu:
      userRole === 'ROOTADMIN' ? ProfileSideBarMenu : UserReportsSideBarMenu,
    meta: {
      title: siteTitle,
      description: siteMetaDescription,
    },
    component: lazy(() => import('./components/Profiles/DriverProfile')),
    beta: false,
  },
  // Vehicle-Profile
  {
    private: true,
    path: '/profiles/vehicle',
    id: 5,
    sideBar: true,
    exact: true,
    sideBarMenu:
      userRole === 'ROOTADMIN' ? ProfileSideBarMenu : UserReportsSideBarMenu,
    meta: {
      title: siteTitle,
      description: siteMetaDescription,
    },
    component: lazy(() => import('./components/Profiles/VehicleProfile')),
    beta: false,
  },
  // Dealer-Profile
  {
    private: true,
    path: '/profiles/dealer',
    id: 6,
    sideBar: true,
    exact: true,
    sideBarMenu:
      userRole === 'ROOTADMIN' ? ProfileSideBarMenu : UserReportsSideBarMenu,
    meta: {
      title: siteTitle,
      description: siteMetaDescription,
    },
    component: lazy(() => import('./components/Profiles/DealerProfile')),
    beta: false,
  },
  // Profiles
  {
    private: true,
    exact: true,
    path: '/profiles',
    id: 7,
    sideBar: false,
    meta: {
      title: siteTitle,
      description: siteMetaDescription,
    },
    component: lazy(() => import('./components/Profiles')),
    beta: false,
  },
  {
    private: true,
    path: '/owner-suite',
    id: 8,
    sideBar: false,
    meta: {
      title: siteTitle,
      description: siteMetaDescription,
    },
    component: lazy(() => import('./components/OwnerSuite/index')),
    beta: false,
  },
  {
    private: true,
    id: 9,
    path: '/cssupport',
    meta: {
      title: siteTitle,
      description: siteMetaDescription,
    },
    sideBar: false,
    component: lazy(() => import('./components/SupportAdminLogin')),
    beta: false,
  },
  {
    private: true,
    path: '/dashboard',
    id: 32,
    sideBar: false,
    meta: {
      title: siteTitle,
      description: siteMetaDescription,
    },
    component: lazy(() => import('./components/Dashboard/index')),
  },
  {
    private: true,
    path: '/trip-management',
    id: 33,
    sideBar: false,
    meta: {
      title: siteTitle,
      description: siteMetaDescription,
    },
    component: lazy(() => import('./components/TripManagement/index')),
    beta: false,
  },
  {
    private: true,
    exact: true,
    path: '/track-trace',
    id: 31,
    sideBar: true,
    // sideBarMenu: myFleetSideMenu,
    meta: {
      title: siteTitle,
      description: siteMetaDescription,
    },
    component: lazy(() => import('./components/Track-Trace/index')),
    beta: true,
  },
  {
    private: true,
    exact: true,
    path: '/profile',
    id: 11,
    sideBar: false,
    // sideBarMenu: myFleetSideMenu,
    meta: {
      title: siteTitle,
      description: siteMetaDescription,
    },
    component: lazy(() => import('./components/Profiles')),
    beta: false,
  },

  {
    private: true,
    exact: true,
    path: '/settings',
    sideBar: false,
    id: 12,
    // sideBarMenu: myFleetSideMenu,
    meta: {
      title: siteTitle,
      description: siteMetaDescription,
    },
    component: lazy(() => import('./components/Settings')),
    beta: false,
  },
  {
    private: true,
    path: '/fleet-healthv2',
    exact: true,
    id: 131,
    // sideBarMenu: myFleetSideMenu,
    sideBar: false,
    meta: {
      title: siteTitle,
      description: siteMetaDescription,
    },
    component: lazy(() => import('./components/FleetHealthV2')),
    beta: true,
  },
  {
    private: true,
    path: '/fleet-healthv2/:vehicleId',
    exact: true,
    id: 132,
    // sideBarMenu: myFleetSideMenu,
    sideBar: false,
    meta: {
      title: siteTitle,
      description: siteMetaDescription,
    },
    component: lazy(() => import('./components/FleetHealthV2/Vehicle/VehicleDtc')),
    beta: true,
  },
  {
    private: true,
    path: '/fleet-efficiency',
    exact: true,
    id: 131,
    // sideBarMenu: myFleetSideMenu,
    sideBar: false,
    meta: {
      title: siteTitle,
      description: siteMetaDescription,
    },
    component: lazy(() => import('./components/Fleet-Efficiency')),
    beta: true,
  },
  {
    private: true,
    path: '/reportsv2',
    exact: true,
    id: 30,
    // sideBarMenu: myFleetSideMenu,
    sideBar: false,
    meta: {
      title: siteTitle,
      description: siteMetaDescription,
    },
    component: lazy(() => import('./components/ReportsV2')),
    beta: true,
  },
  // Customer-Admin
  {
    private: true,
    path: '/profiles/customer-admin',
    sideBar: true,
    id: 16,
    exact: true,
    sideBarMenu:
      userRole === 'ROOTADMIN' ? ProfileSideBarMenu : UserReportsSideBarMenu,
    meta: {
      title: siteTitle,
      description: siteMetaDescription,
    },
    component: lazy(() => import('./components/Profiles/CustomerAdmin')),
  },
  // My Profiles
  {
    private: true,
    path: '/profiles/my-profile',
    sideBar: true,
    id: 17,
    exact: true,
    sideBarMenu:
      userRole === 'ROOTADMIN' ? ProfileSideBarMenu : UserReportsSideBarMenu,
    meta: {
      title: siteTitle,
      description: siteMetaDescription,
    },
    component: lazy(() => import('./components/Profiles/MyProfile')),
    beta: false,
  },
  // Setting
  {
    private: true,
    path: '/settings',
    id: 26,
    sideBar: false,
    exact: true,
    meta: {
      title: siteTitle,
      description: siteMetaDescription,
    },
    component: lazy(() => import('./components/Settings')),
    beta: false,
  },
  // Setting
  {
    private: true,
    path: '/support',
    id: 27,
    sideBar: false,
    exact: true,
    meta: {
      title: siteTitle,
      description: siteMetaDescription,
    },
    component: lazy(() => import('./components/Settings/Help')),
    beta: false,
  },
  {
    private: true,
    path: '/alerts',
    id: 28,
    sideBar: true,
    exact: true,
    meta: {
      title: siteTitle,
      description: siteMetaDescription,
    },
    component: lazy(() => import('./components/Alerts')),
    beta: true,
  },
  {
    private: true,
    path: '/driving-analysisv2',
    id: 29,
    sideBar: true,
    exact: true,
    meta: {
      title: siteTitle,
      description: siteMetaDescription,
    },
    component: lazy(() => import('./components/DrivingAnalysisV2')),
    beta: true,
  },
  // Demo
  {
    private: true,
    path: '/demo',
    id: 30,
    sideBar: true,
    exact: true,
    meta: {
      title: siteTitle,
      description: siteMetaDescription,
    },
    component: lazy(() => import('./components/Demo')),
    beta: true,
  },
];

export default ROUTE;
